import ACCOUNTING_PAGE_DATA from './pages/accounting';
import COMMON_PAGE_DATA from './pages/common';
import COPERATE_PAGE_DATA from './pages/coperate';
import PERSONAL_PAGE_DATA from './pages/personal';
import SALARY_INSURANCE_PAGE_DATA from './pages/salaryinsurance';
import VAT_PAGE_DATA from './pages/vat';

export const routes = {
    Accounting: ACCOUNTING_PAGE_DATA,
    Common: COMMON_PAGE_DATA,
    Coperate: COPERATE_PAGE_DATA,
    Personal: PERSONAL_PAGE_DATA,
    SalaryInsurance: SALARY_INSURANCE_PAGE_DATA,
    Vat: VAT_PAGE_DATA,
};